import { render, staticRenderFns } from "./comment-section.vue?vue&type=template&id=2eb527f6&scoped=true"
import script from "./comment-section.vue?vue&type=script&lang=js"
export * from "./comment-section.vue?vue&type=script&lang=js"
import style0 from "./comment-section.vue?vue&type=style&index=0&id=2eb527f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb527f6",
  null
  
)

export default component.exports